module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_7_4.8120ddc4.jpeg";